import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import { pixiApp } from '../components/pixi/PixiApp';
import { TweenLite } from 'gsap';
import sortChaptersById from '../components/exhibition/sortChaptersById';
import Helmet from 'react-helmet';

import $ from 'jquery';

import NextSectionArrow from '../components/chapter/NextSectionArrow';
import ChapterSectionImageText from '../components/chapter/ChapterSectionImageText';
import ChapterSectionQuote from '../components/chapter/ChapterSectionQuote';
import ChapterSectionPressPlay from '../components/chapter/ChapterSectionPressPlayPixi';
import ChapterSectionSplit from '../components/chapter/ChapterSectionSplit';
import ChapterSectionVideo from '../components/chapter/ChapterSectionVideo';
import ChapterSectionLoader from '../components/chapter/ChapterSectionLoader';

import style from './Chapter.module.scss';

let fullpage;
let scrollOverflow;

class Chapter extends Component {
  state = {
    isPlaylistOpen: false,
    isVideoOpen: false,
    isLastSection: false,
    isLastChapter: false,
    exitingDrawn: false,
    exitSlide: null,
    preExit: false,
    arrowStyle: 'white',
    hasBackground: false,
    currentSlideIndex: 0,
  };
  title = this.props.data.chapter.title
    .replace('<strong>', '')
    .replace('</strong>', '');
  isLastChapter = this.checkIsLastChapter();
  isExiting = false;
  isScrolling = false;
  activeImages = [];

  componentWillMount() {
    this.chapterData = this.props.data.chapter;
    this.exhibitionData = this.props.data.exhibitionData.edges[0].node;
    this.chapterColor = this.chapterData.color_theme;
    this.totalChapters = this.exhibitionData.chapters.length;

    const id =
      typeof this.chapterData.id === 'string'
        ? parseInt(this.chapterData.id, 10)
        : this.chapterData.id;
    this.chapterIndex = this.exhibitionData.chapters.indexOf(id);

    const chapterIds = this.props.data.exhibitionData.edges[0].node.chapters;
    const chapters = this.props.data.chapterData.edges.map(edge => edge.node);
    this.sortedChapters = sortChaptersById(chapterIds, chapters);
  }

  componentDidMount() {
    this.props.registerChapterExit(this.exitChapter);
    this.props.setThemeColor(this.props.data.chapter.color_theme);

    window.jQuery = $;
    window.IScroll = require('iscroll');
    scrollOverflow = require('fullpage.js/vendors/scrolloverflow.js');
    fullpage = require('fullpage.js');
    const scrollSpeed = 700;
    const fullpageOptions = {
      // navigation: false,
      scrollingSpeed: scrollSpeed,
      // autoScrolling: true,
      scrollOverflow: true,
      // scrollBar: false,

      // easingcss3: 'cubic-bezier(0.77, 0, 0.175, 1)',
      onLeave: (index, nextIndex, direction) => {
        // can't trigger another scroll until finished first
        // and don't scroll while exiting
        if (this.isScrolling || this.isExiting) {
          return false;
        }
        this.isScrolling = true;
        setTimeout(() => {
          this.isScrolling = false;
        }, scrollSpeed);
        this.props.setHeaderStyleFromSection(
          this.chapterData.exhibition_sections[nextIndex - 1]
        );
        this.setState({ currentSlideIndex: nextIndex - 1 });
        this.setArrowStyle(this.chapterData.exhibition_sections[nextIndex - 1]);
        if (nextIndex === $('.fp-section').length) {
          this.setState({
            isLastSection: true,
          });
        } else {
          this.setState({
            isLastSection: false,
          });
        }
      },
    };

    // Initialize fullpage.js
    if (typeof window !== 'undefined') {
      $(this.fullpage).fullpage(fullpageOptions);

      // for dev, can put slide=4 in url to skip to a slide on refresh
      if (this.props.location.search.indexOf('slide') !== -1) {
        const slideDest = parseInt(
          this.props.location.search.split('slide')[1].split('=')[1],
          10
        );
        setTimeout(() => {
          $.fn.fullpage.moveTo(slideDest, 0);
        }, 2000);
      }
      window.addEventListener('mousedown', this.disallowScroll);
      window.addEventListener('mouseup', this.allowScroll);
    }

    this.props.setHeaderStyleFromSection(
      this.chapterData.exhibition_sections[0]
    );
    this.setArrowStyle(this.chapterData.exhibition_sections[0]);
    setTimeout(() => {
      this.setState({ hasBackground: true });
    }, 1000);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.disallowScroll);
    window.removeEventListener('mouseup', this.allowScroll);

    // Destroy fullpage.js
    if (typeof window !== 'undefined') $.fn.fullpage.destroy('all');
  }

  componentWillUpdate(nextProps, nextState) {
    // console.log(this.props.screenOrientation, nextProps.screenOrientation);
    if (
      typeof window !== 'undefined' &&
      this.props.screenOrientation !== nextProps.screenOrientation
    ) {
      $.fn.fullpage.reBuild();
    }
  }
  allowScroll = () => {
    if (!this.state.isPlaylistOpen && !this.state.isVideoOpen) {
      // console.log('allowScroll');
      $.fn.fullpage.setAllowScrolling(true);
      $.fn.fullpage.setKeyboardScrolling(true);
    }
  };
  disallowScroll = () => {
    // console.log('disallowScroll');
    $.fn.fullpage.setAllowScrolling(false);
    $.fn.fullpage.setKeyboardScrolling(false);
  };
  componentDidUpdate(prevProps, prevState) {
    // Enable/disable fullpage.js
    if (
      (this.state.isPlaylistOpen !== prevState.isPlaylistOpen ||
        this.state.isVideoOpen != prevState.isVideoOpen) &&
      typeof window !== 'undefined'
    ) {
      if (this.state.isPlaylistOpen || this.state.isVideoOpen) {
        this.disallowScroll();
      } else {
        this.allowScroll();
      }
    }
  }
  setArrowStyle(data) {
    switch (data.section_type) {
      case 'split_image_and_text':
        this.setState({ arrowStyle: 'fill' });
        break;
      default:
        this.setState({ arrowStyle: 'white' });
    }
  }
  exitAfterDraw = () => {
    //active slide exit animation is fired
    this.setState({
      exitingDrawn: true,
    });
    const activeSection = document.querySelector('.fp-section.active');
    const chapterWrap = document.querySelector('.js-chapterWrapper');
    if (activeSection) {
      activeSection.style.background = 'transparent';
    }
    if (chapterWrap) {
      chapterWrap.style.background = 'transparent';
    }
  };

  // Function that gets passed down to children. Every slide always sets a ref to current image.
  setActiveImage = (index, url) => {
    this.activeImages[index] = url;
  };

  getSlideImageAndType(data, activeIndex) {
    const url = this.activeImages[activeIndex];

    switch (data.section_type) {
      case 'quote':
      case 'full_width_image_with_text':
      case 'video':
        return {
          imgPath: url,
          type: 'full',
          startScreenAlpha: 0.4,
          endScreenAlpha: 0,
        };
      case 'split_image_and_text':
        return {
          imgPath: url,
          type: data.image_alignment === 'left' ? 'half-left' : 'half-right',
          startScreenAlpha: 0.4,
          endScreenAlpha: 0,
        };
      case 'press_and_hold':
        return {
          imgPath: url,
          type: 'full',
          startScreenAlpha: 0.6,
          endScreenAlpha: 0.6,
        };

      default:
        throw 'slide type exit not handled yet ~Chris';
    }
  }

  getSlideExitTime(type) {
    switch (type) {
      case 'press_and_hold':
        return 700;
      default:
        return 500;
    }
  }
  exitChapter = targetIndex => {
    // don't fire multple times if button couble clicked
    if (this.isExiting) return;
    this.isExiting = true;

    // no scrolling during exit
    this.disallowScroll();

    let nextIndex;
    if (typeof targetIndex === 'undefined') {
      if (this.chapterIndex < this.sortedChapters.length - 1) {
        nextIndex = this.chapterIndex + 1;
      } else {
        nextIndex = 0;
      }
      nextIndex;
    } else {
      nextIndex = targetIndex;
    }
    const activeSlide = document.querySelector('.fp-section.active');
    const allSlides = Array.from(document.querySelectorAll('.fp-section'));
    const activeIndex = allSlides.indexOf(activeSlide);

    this.setState({
      preExit: true,
      exitSlide: activeIndex,
      hasBackground: false,
    });

    // sets slider into position before doing slide exit animation
    pixiApp.startChapterExit(this.chapterIndex);
    this.props.beforeExitChapter(nextIndex);
    // fade out chapter UI, could do this better :/
    // TweenLite.to('.js-dropdownNav', 0.35, { opacity: 0 });
    // TweenLite.to('.js-chapterNav', 0.35, { opacity: 0 });
    TweenLite.to('.js-nextSectionArrow ', 0.35, { opacity: 0 });

    // console.log(this.props.data.chapter.exhibition_sections);
    // figure out the current slide
    // get that slide's image and type
    const sectionData = this.props.data.chapter.exhibition_sections;
    const currentData = sectionData[activeIndex];
    const slideImageAndType = this.getSlideImageAndType(
      currentData,
      activeIndex
    );

    const slideExitTime = this.getSlideExitTime(currentData.section_type);

    setTimeout(() => {
      this.props.onExitChapter(nextIndex);

      //disable scroll
      this.disallowScroll();

      // setup pixi to do the transition
      pixiApp.exitToChapter(
        slideImageAndType.type,
        slideImageAndType.imgPath,
        this.exitAfterDraw,
        this.chapterIndex,
        nextIndex,
        // after pan callback: move Pixi canvas back behind exhibition
        () => {
          this.props.pixiBehindExhibition();
        },
        // complete callback: update route
        () => {
          //enable scroll before removing listeners
          this.allowScroll();
          navigateTo(`${this.exhibitionData.path}`);
        },
        slideImageAndType.startScreenAlpha,
        slideImageAndType.endScreenAlpha,
        undefined,
        undefined,
        this.state.currentSlideIndex
      );

      this.props.setHeaderStyleFromSection(null, true);
    }, slideExitTime);
  };

  goToNextSection = () => {
    // console.log('go to next seciton');
    // Handle next section button/next chapter button functionality swap
    if (this.state.isLastSection) {
      this.disallowScroll();
      if (this.isLastChapter) {
        // navigate to timeline
        const path = this.props.settingsContent.menu.filter(
          data => data.title === 'Timeline'
        )[0].path;
        navigateTo(path);
      } else {
        this.exitChapter();
      }
    } else {
      this.allowScroll();
      $.fn.fullpage.moveSectionDown();
    }
  };

  setPlaylistOpen = value => {
    this.setState({
      isPlaylistOpen: value,
    });
  };

  setVideoOpen = value => {
    this.setState({
      isVideoOpen: value,
    });
  };

  handleDropdownChange = () => {
    this.setState(state => ({
      isDropdownNavOpen: !state.isDropdownNavOpen,
    }));
  };

  setChapterThemeClass = color => {
    switch (color) {
      case 'blue':
        return `chapter-theme--blue`;
      case 'yellow':
        return `chapter-theme--yellow`;
      case 'green':
        return `chapter-theme--green`;
      default:
        return `chapter-theme--red`;
    }
  };
  checkIsLastChapter() {
    return (
      this.props.data.chapter.path ===
      this.props.data.chapterData.edges[
        this.props.data.chapterData.edges.length - 1
      ].node.path
    );
  }
  render() {
    return (
      <div
        className={`${
          style.chapterWrapper
        } js-chapterWrapper ${this.setChapterThemeClass(this.chapterColor)} ${
          this.state.hasBackground ? 'chapter-theme--background' : ''
        } `}
      >
        <Helmet title={`${this.title} | The House on Henry Street`} />

        <NextSectionArrow
          isPlaylistOpen={this.state.isPlaylistOpen}
          isLastSection={this.state.isLastSection}
          goToNextSection={this.goToNextSection}
          arrowStyle={this.state.arrowStyle}
          isLastChapter={this.isLastChapter}
        />
        {this.chapterData && (
          <div className={`fullPage`} ref={el => (this.fullpage = el)}>
            {this.chapterData.exhibition_sections.map((section, index) => {
              const sectionProps = {
                ...this.props,
                key: `${section.section_type}-${index}`,
                sectionData: section,
                setActiveImage: this.setActiveImage,
                isFirst: index === 0,
                disallowScroll: this.disallowScroll,
                allowScroll: this.allowScroll,
                index: index,
                exitingDrawn:
                  this.state.exitingDrawn && this.state.exitSlide === index,
                preExit: this.state.preExit && this.state.exitSlide === index,
              };
              switch (section.section_type) {
                case 'video':
                  return (
                    <ChapterSectionLoader
                      currentIndex={this.state.currentSlideIndex}
                      sectionIndex={index}
                      key={`chapterSection${index}`}
                    >
                      <ChapterSectionVideo
                        {...sectionProps}
                        isVideoOpen={this.state.isVideoOpen}
                        setVideoOpen={this.setVideoOpen}
                        isChapter={true}
                      />
                    </ChapterSectionLoader>
                  );
                case 'full_width_image_with_text':
                  return (
                    <ChapterSectionLoader
                      currentIndex={this.state.currentSlideIndex}
                      sectionIndex={index}
                      key={`chapterSection${index}`}
                    >
                      <ChapterSectionImageText {...sectionProps} />
                    </ChapterSectionLoader>
                  );
                case 'split_image_and_text':
                  return (
                    <ChapterSectionLoader
                      currentIndex={this.state.currentSlideIndex}
                      sectionIndex={index}
                      key={`chapterSection${index}`}
                    >
                      <ChapterSectionSplit {...sectionProps} />
                    </ChapterSectionLoader>
                  );
                case 'press_and_hold':
                  return (
                    <ChapterSectionLoader
                      currentIndex={this.state.currentSlideIndex}
                      sectionIndex={index}
                      key={`chapterSection${index}`}
                    >
                      <ChapterSectionPressPlay
                        {...this.state}
                        {...sectionProps}
                        isChapter={true}
                        setPlaylistOpen={this.setPlaylistOpen}
                        isCurrentSlide={this.state.currentSlideIndex === index}
                      />
                    </ChapterSectionLoader>
                  );
                case 'quote':
                  return (
                    <ChapterSectionLoader
                      currentIndex={this.state.currentSlideIndex}
                      sectionIndex={index}
                      key={`chapterSection${index}`}
                    >
                      <ChapterSectionQuote {...sectionProps} />
                    </ChapterSectionLoader>
                  );
                default:
                  return '';
              }
            })}
          </div>
        )}
      </div>
    );
  }
}

export default Chapter;

export const chapterQuery = graphql`
  query chapterQuery($path: String!) {
    exhibitionData: allDataJson(filter: { post_type: { eq: "exhibition" } }) {
      edges {
        node {
          post_type
          chapters
          path
        }
      }
    }
    chapterData: allDataJson(filter: { post_type: { eq: "chapter" } }) {
      edges {
        node {
          path
          id
          title
        }
      }
    }
    chapter: dataJson(path: { eq: $path }) {
      id
      post_type
      path
      title
      color_theme
      exhibition_sections {
        section_type
        title
        subtitle
        body
        image_alignment
        quote_text
        caption
        video_source
        vimeo_id
        youtube_id
        video_file {
          id
          url
        }
        image {
          alt
          url
          sizes {
            large
          }
        }
        is_quote
        attribution
        images {
          alt
          id
          sizes {
            #medium
            large
          }
        }
        playlists {
          title
          label
          watermark
          image {
            url
            alt
            sizes {
              large
            }
          }
          slides {
            body
            body_quadrant
            image_portrait {
              url
              alt
            }
            source {
              landscape {
                id
                url
              }
              portrait {
                url
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/chapter.js